export default "__VITE_ASSET__XLtimYvV__"